// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"LoaderPage_loader_wrapper__FjO+M","loader":"LoaderPage_loader__QxyYD","l5":"LoaderPage_l5__3-f-q"};